import { workerList } from "./initiateWebWorkers"

let index = 0

/**
 * Returns a web worker from the list of workers
 * 
 * Uses a round-robin distribution algorithm
 */
export default function getNextWebWorker() {
  index = (index+1) % workerList.length
  return workerList[index]!
}